


















import Vue from 'vue';

import { mapGetters } from 'vuex';
import ImportCard from '@/pages/import/ImportCard.vue';
import { keysToSnake } from '@/utils';

export default Vue.extend({
  name: 'AswStep3ImportCard',
  components: {
    ImportCard,
  },
  props: {
    managedIn: {
      type: String,
      required: true,
    },
    auditCode: {
      type: String,
      required: true,
    },
    userEmail: {
      type: String,
      required: true,
    },
    extendedMessage: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      featureFlagState: 'featureFlagState',
    }),
    managedExternaly(): boolean {
      return ['JIRA', 'SERVICENOW'].includes(this.managedIn);
    },
    headers(): any {
      const objectType = this.getObjectType;
      const auditSlug = this.auditCode;
      const fixedValues = [
        {
          objectType,
          column: 'Audit*',
          value: auditSlug,
        },
      ];
      if (objectType === 'Request') {
        fixedValues.push(
          {
            objectType,
            column: 'Status*',
            value: 'Open',
          },
          {
            objectType,
            column: 'Requester*',
            value: this.userEmail,
          }
        );
      }

      // Workaround: Jira and Servicenow templates does not have
      // slug (code) column, but the converter still expects it.
      // We therefore provide empty column values to make
      // converter happy.
      if (objectType === 'Jira Issue' || objectType === 'Servicenow Task') {
        fixedValues.push({
          objectType,
          column: 'Code*',
          value: '',
        });
      }

      const headers = {
        'X-allowed-types': JSON.stringify([objectType]),
        'X-fixed-values': JSON.stringify(keysToSnake(fixedValues)),
      };

      return headers;
    },
    getObjectType() {
      if (this.featureFlagState('new_ticketing')) {
        switch (this.managedIn.toUpperCase()) {
          case 'JIRA':
            return 'Jira Issue';
          case 'SERVICENOW':
            return 'Ticketing Task';
          default:
            return 'Request';
        }
      } else {
        switch (this.managedIn.toUpperCase()) {
          case 'JIRA':
            return 'Jira Issue';
          case 'SERVICENOW':
            return 'Servicenow Task';
          default:
            return 'Request';
        }
      }
    },
  },
});
